import { render, staticRenderFns } from "./LeafletGroup.vue?vue&type=template&id=08fb05a8&"
import script from "./LeafletGroup.vue?vue&type=script&lang=js&"
export * from "./LeafletGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports